module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-home"
  }, [_c('carousel', {
    ref: "carousel",
    attrs: {
      "loop": true,
      "perPage": 1,
      "autoplayHoverPause": false,
      "paginationActiveColor": '#613A7D',
      "autoplay": true,
      "autoplayTimeout": 20000,
      "navigationEnabled": true
    }
  }, _vm._l((_vm.svgListFinal), function(svg, index) {
    return _c('slide', {
      key: index
    }, [_c('div', {
      staticClass: "svg-container",
      domProps: {
        "innerHTML": _vm._s(svg)
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-7e5d504a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/home.vue
// module id = 2181
// module chunks = 1